import { createContext, useContext } from 'react';

interface RemoveWidgetContextType {
  openRemoveModal: (onOk: () => void) => void;
}

export const RemoveWidgetContext = createContext<RemoveWidgetContextType | undefined>(undefined);

export const useRemoveWidgetContext = () => {
  const context = useContext(RemoveWidgetContext);
  if (!context) throw new Error('useRemoveWidgetContext must be used within RemoveWidgetProvider');
  return context;
};
